export const outlookAdminConsentApprovedPath = "/outlook-admin-consent/approved";
export const outlookAdminConsentNotApprovedPath = "/outlook-admin-consent/not-approved";
//# sourceMappingURL=outlook-admin-consent.js.map